import React, { useEffect, useState } from 'react';
import { Paper } from '@material-ui/core';
import CustomButton from 'src/common/components/CustomButton';
import notice from 'src/common/components/Notice';
import TreeViewComponent from 'src/common/components/TreeViewComponent';
import { startLog } from 'src/api/modules/bitacora';
import AddOrganModal from './components/AddOrganModal';
import EditOrganModal from './components/EditOrganModal';
import DeleteOrganModal from './components/DeleteOrganModal';
import { organsAPI } from 'src/api/modules/organs';
import { editBodyForm } from './utils/form_data';
import PageLayout from 'src/common/components/PageLayout';

const CollegiateBody = () => {
	const [organs, setOrgans] = useState([]);
	const [activeOrgan, setActiveOrgan] = useState(editBodyForm);
	const [addBodyModal, setAddBodyModal] = useState(false);
	const [editBodyModal, setEditBodyModal] = useState(false);
	const [deleteBodyModal, setDeleteBodyModal] = useState(false);

	useEffect(() => {
		getDataFromApi();
		startLog('Ingreso a la vista Configuracion');
	}, []);

	const getDataFromApi = () => {
		organsAPI
			.get('get')
			.then((response) => setOrgans(response || []))
			.catch(() => notice('Error al traer la lista de órganos colegiados'));
	};

	const onAddChild = (item) => {
		setActiveOrgan({ ...item });
		setAddBodyModal(true);
	};

	const onEditChild = (item) => {
		setActiveOrgan({ ...item });
		setEditBodyModal(true);
	};

	const onDeleteChild = (item) => {
		setActiveOrgan({ ...item });
		setDeleteBodyModal(true);
	};

	const onChangeStatus = (item) => {
		let newStatus = item.estatus === 'A' ? 'I' : 'A';
		const organ = { ...item, estatus: newStatus };
		delete organ.organos;
		organsAPI
			.put(item.id, { ...organ })
			.then(() => {
				notice(
					`Se ${
						organ.estatus === 'I' ? 'desactivo' : 'acctivo'
					} correctamente el órgano colegiado`,
					'success'
				);
				getDataFromApi();
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	const onCloseModalAdd = () => {
		setActiveOrgan(editBodyForm);
		setAddBodyModal(false);
	};

	const onCloseModalEdit = () => {
		setActiveOrgan(editBodyForm);
		setEditBodyModal(false);
	};

	const onCloseModalDelete = () => {
		setActiveOrgan(editBodyForm);
		setDeleteBodyModal(false);
	};

	const onChangeData = ({ target }) => {
		setActiveOrgan({ ...activeOrgan, [target.name]: target.value });
	};

	const onSuccess = (msg, type_msg, type) => {
		notice(msg, type_msg);
		switch (type) {
			case 1:
				onCloseModalAdd();
				break;
			case 2:
				onCloseModalEdit();
				break;
			case 3:
				onCloseModalDelete();
				break;
			default:
				break;
		}
		getDataFromApi();
	};

	return (
		<PageLayout title="Órganos Colegiados">
			<CustomButton
				mainText="Agregar Órgano Colegiado"
				color="primary"
				onClick={() => setAddBodyModal(true)}
				className="mb-5"
			/>
			<Paper elevation={0}>
				<TreeViewComponent
					items={organs}
					onAddChild={(item) => onAddChild(item)}
					onEditChild={(item) => onEditChild(item)}
					onDeleteChild={(item) => onDeleteChild(item)}
					onChangeStatus={(item) => onChangeStatus(item)}
				/>
			</Paper>
			<AddOrganModal
				open={addBodyModal}
				parent={activeOrgan}
				onClose={onCloseModalAdd}
				onSuccess={onSuccess}
				onChangeData={onChangeData}
			/>
			<EditOrganModal
				organ={activeOrgan}
				open={editBodyModal}
				onClose={onCloseModalEdit}
				onSuccess={onSuccess}
				onChangeData={onChangeData}
			/>
			<DeleteOrganModal
				open={deleteBodyModal}
				organ={activeOrgan}
				onClose={onCloseModalDelete}
				onSuccess={onSuccess}
			/>
		</PageLayout>
	);
};

export default CollegiateBody;
